<header class="header">
  <div class="d-flex justify-content-between align-items-center p-2">
    
    <!-- Left: Logo -->
    <div class="logo-container">
      <img src="assets/images/efficx_logo_small.png" alt="brand-logo" class="img-logo">
    </div>

    <!-- Right: Dropdown -->
    <div class="dropdown">
      <button class="btn btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
        <i class="bi bi-person-fill"></i> {{ userName }}
      </button>
      <ul class="dropdown-menu dropdown-menu-end">
  <li>
    <a class="dropdown-item" (click)="goToDashboard()">
      <i class="bi bi-speedometer2"></i> Dashboard
    </a>
  </li>

  <li>
    <a class="dropdown-item" (click)="goToLinkRoute('update-password')">
      <i class="bi bi-shield-lock"></i> Change Password
    </a>
  </li>

  <li>
    <a class="dropdown-item" (click)="goToLinkRoute('user-profile')">
      <i class="bi bi-person-fill"></i> Profile
    </a>
  </li>

  <li>
    <a class="dropdown-item" type="button" (click)="logout()">
      <i class="bi bi-box-arrow-right"></i> Logout
    </a>
  </li>
</ul>
    </div>

  </div>
</header>